// extracted by mini-css-extract-plugin
export default {"title-card":"TitleCard_title-card__Iz2KZ","sub-title-card":"TitleCard_sub-title-card__DzHpB"};